import { Button } from "@/components/ui/button";

export function PricingControls({ priceSource, setPriceSource, includeAssessment, setIncludeAssessment, includeCompanyVisits, setIncludeCompanyVisits }: {
  priceSource: string;
  setPriceSource: (v: string) => void;
  // Only the dashboard subtracts the assessment, so the Kunder tab passes neither.
  includeAssessment?: boolean;
  setIncludeAssessment?: (v: boolean) => void;
  includeCompanyVisits?: boolean;
  setIncludeCompanyVisits?: (v: boolean) => void;
}) {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <div className="flex items-center gap-1.5">
        <span className="text-xs text-admin-text-subtle">Furst:</span>
        <div className="flex items-center gap-0.5 rounded-md bg-admin-card p-0.5">
          <Button
            variant={priceSource === "FURST_DISCOUNTED" ? "default" : "ghost"}
            size="sm"
            className="text-xs px-2 py-0.5 h-auto"
            onClick={() => setPriceSource("FURST_DISCOUNTED")}
          >
            Avtale
          </Button>
          <Button
            variant={priceSource === "FURST" ? "default" : "ghost"}
            size="sm"
            className="text-xs px-2 py-0.5 h-auto"
            onClick={() => setPriceSource("FURST")}
          >
            Liste
          </Button>
        </div>
      </div>

      {setIncludeAssessment && (
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-admin-text-subtle">Legevurdering:</span>
          <div className="flex items-center gap-0.5 rounded-md bg-admin-card p-0.5">
            <Button
              variant={includeAssessment ? "default" : "ghost"}
              size="sm"
              className="text-xs px-2 py-0.5 h-auto"
              onClick={() => setIncludeAssessment(true)}
            >
              Med
            </Button>
            <Button
              variant={!includeAssessment ? "default" : "ghost"}
              size="sm"
              className="text-xs px-2 py-0.5 h-auto"
              onClick={() => setIncludeAssessment(false)}
            >
              Uten
            </Button>
          </div>
        </div>
      )}

      {setIncludeCompanyVisits && (
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-admin-text-subtle">Bedriftsbesøk:</span>
          <div role="group" aria-label="Bedriftsbesøk" className="flex items-center gap-0.5 rounded-md bg-admin-card p-0.5">
            <Button
              aria-pressed={!includeCompanyVisits}
              variant={!includeCompanyVisits ? "default" : "ghost"}
              size="sm"
              className="text-xs px-2 py-0.5 h-auto"
              onClick={() => setIncludeCompanyVisits(false)}
            >
              Uten
            </Button>
            <Button
              aria-pressed={includeCompanyVisits}
              variant={includeCompanyVisits ? "default" : "ghost"}
              size="sm"
              className="text-xs px-2 py-0.5 h-auto"
              onClick={() => setIncludeCompanyVisits(true)}
            >
              Med
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
